import { render, staticRenderFns } from "./witholdinvoice.vue?vue&type=template&id=d2455bd6"
import script from "./witholdinvoice.vue?vue&type=script&lang=js"
export * from "./witholdinvoice.vue?vue&type=script&lang=js"
import style0 from "./witholdinvoice.vue?vue&type=style&index=0&id=d2455bd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports